import React from 'react';
import ReactGA from 'react-ga4';

export default function AppLink({ href, children, ...props }) {
    const handleClick = () => {
        ReactGA.event({
          category: 'Outbound Link',
          action: 'Click',
          label: href
        });
    };

    
    return (
        <a href={href} onClick={handleClick} {...props} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    );
}